function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#03B8DF",
  d: "M0 7h16v2H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#03B8DF",
  d: "M9 0v16H7V0z"
});

var SvgExpanded = function SvgExpanded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgExpanded;